import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader } from 'lucide-react';
import securityApi from '../../api/securityApi';

const ComplianceRedirect = () => {
  const [redirectTo, setRedirectTo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await securityApi.listComplianceProjects();
        const projects = response.projects || [];
        if (projects.length > 0) {
          setRedirectTo(`/compliance/projects/${projects[0].id}`);
        } else {
          setRedirectTo('/compliance/new');
        }
      } catch {
        setRedirectTo('/compliance/new');
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader className="w-8 h-8 text-teal-600 animate-spin" />
      </div>
    );
  }

  return <Navigate to={redirectTo} replace />;
};

export default ComplianceRedirect;
